// extracted by mini-css-extract-plugin
export default {"root":"Map_root__w1Ang","radTop":"Map_radTop__lNFfk","label":"Map_label__sLjsJ","layerSwitcher":"Map_layerSwitcher__dEN9L","sizeSwitcher":"Map_sizeSwitcher__6GHEP"};